<template>
  <ion-row
    v-if="property && property?.PropertyType"
    class="d-flex ion-justify-content-center ion-align-items-center"
  >
    <ion-col size="12" class="d-flex gap-sm ion-align-items-center">
      <div class="d-flex ion-align-items-center">
        <ion-icon :icon="businessOutline" color="placeholder" />
        <span class="text-color-placeholder truncate-text text-small text-weight-bold">{{
          property.PropertyType[`name_${language}` as keyof ContractModelRelation]
        }}</span>
      </div>

      <div>-</div>

      <div class="d-flex ion-align-items-center">
        <ion-icon :icon="bedOutline" color="placeholder" />
        <span class="text-color-placeholder text-small text-weight-bold">
          {{ property.totalRUs }}
          {{ property.totalRUs === 1 ? t('announcement.bedroom') : t('announcement.bedrooms') }}
        </span>
      </div>
    </ion-col>
  </ion-row>
</template>

<script setup lang="ts">
  import { IonIcon, IonRow, IonCol } from '@ionic/vue';
  import { Property, ContractModelRelation } from '@/interfaces/elastic/elastic.interface';
  import { businessOutline, bedOutline } from 'ionicons/icons';
  import { useI18n } from 'vue-i18n';

  withDefaults(
    defineProps<{
      property: Property;
      language: string;
    }>(),
    {},
  );

  const { t } = useI18n();
</script>
